import View from './view';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {notificationsSelector} from '../../../redux/selectors/snackbar';
import {removeNotification} from '../../../redux/actions/snackbar';

export const Snackbar = () => {
  const notifications = useSelector(notificationsSelector());
  const dispatch = useAppDispatch();

  const onCloseAdditional = (id: string) => {
    dispatch(removeNotification(id));
  };
  return View({
    notifications,
    onCloseAdditional,
  });
};
